import React from 'react';

const StickyContact = () => (
  <div className="sticky-contact">
    <a className="btn" href="tel:0423358158">Call 0423 358 158</a>
    <a className="btn" href="#contact">Get a Free Quote</a>
  </div>
);

export default StickyContact;


